import Collection from './generic/collection'
import { getCfg } from './utils/getCfg'

const instance = '[data-js-click-to-copy]'

class ClickToCopy {
  els = {
    instance: '[data-js-click-to-copy]',
    tip: '[data-js-click-to-copy-tip]'
  }

  defaultCfg = {
    target: null
  }

  constructor (instance) {
    this.instance = instance
    this.cfg = getCfg(this.instance, this.els.instance, this.defaultCfg)
    this.init()
  }

  init () {
    this.targetEl = this.cfg.target ? this.getTargetEl(this.cfg.target) : this.instance
    this.textContent = this.targetEl ? this.targetEl.textContent : null
    this.bindEvents()
  }

  getTargetEl(selector) {
    return document.querySelector(selector)
  }

  copyToClipboard (textToCopy) {
    textToCopy = textToCopy.trim()
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(textToCopy)
    } else {
      let input = document.createElement('textarea')
      input.value = textToCopy
      input.style.position = 'fixed'
      input.style.left = '-999999px'
      input.style.top = '-999999px'
      document.body.appendChild(input)
      input.focus()
      input.select()
      if (Promise) {
        return new Promise(function (res, rej) {
          document.execCommand('copy') ? res() : rej()
          input.remove()
        })
      } else {
        document.execCommand('copy')
        input.remove()
      }
    }
  }

  handleClick (e) {
    e.stopPropagation()
    if (this.textContent) {
      this.copyToClipboard(this.textContent)
    }
    else {
      console.debug('Text to copy not found!')
    }
  }

  bindEvents () {
    this.instance.addEventListener('click', (e) => {this.handleClick(e)})
  }
}

export class ClickToCopyCollection extends Collection {
  constructor () {
    super(instance, ClickToCopy)
    this.init()
  }

  init () {
    $(instance).each((index, el) => {
      this.collection = new ClickToCopy(el)
    })
  }

}
